import React, { Component } from 'react';


class GetError extends Component {
    constructor(props){
        super(props)
    }

    render(){

        let divstyle = { 'wordWrap': 'break-word' }
        return(
            <div className="ui divided three column grid">
                <div className="row">
                    <div className="column">
                    </div>
                    <div className="ui column segment" >
                        <div className="ui center aligned container" style={divstyle}>
                            <div className="ui negative message">
                                <div className="header">{this.props.data.error}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default GetError



// WEBPACK FOOTER //
// ./src/components/Protected/Response/GetError.js